import React, { Component } from "react";
import config from "../../config.json";
import httpService from "../../services/httpService";
import {
  Spinner,
  Accordion,
  Card,
  Button,
  OverlayTrigger,
  Popover
} from "react-bootstrap";
import { GiBrokenBottle } from "react-icons/gi";
import { MdSupervisorAccount, MdDone } from "react-icons/md";
import authService from "../../services/authService";
import { Tooltip } from "react-bootstrap";

class HouseKeeping extends Component {
  state = {};

  componentDidMount = () => {
    this.nahrajHousekeeping();
  };

  componentWillUnmount = () => {
    if (this.reload) {
      clearTimeout(this.reload);
    }
  };

  nahrajHousekeeping = async () => {
    const housekeeping = await httpService.post(
      config.apiEndpoint + "housekeeping/vypis.php"
    );
    this.setState({ loaded: true, housekeeping: housekeeping.data.budovy });
    this.reload = setTimeout(this.nahrajHousekeeping, 15000);
  };

  render() {
    const { loaded, housekeeping } = this.state;
    const user = authService.getCurrentUser();

    if (user.housekeeping !== "1") {
      return <div className="alert alert-danger">Nemáte sem přístup!</div>;
    }

    return (
      <React.Fragment>
        {!loaded ? (
          <div className="text-warning">
            <Spinner animation="grow" size="sm" variant="warning" />
            Loading...
          </div>
        ) : housekeeping && housekeeping.length > 0 ? (
          <React.Fragment>
            <Accordion>
              {housekeeping.map((h, index) => (
                <Card key={index+1}>
                  <Accordion.Toggle as={Card.Header} eventKey={index+1}>
                    {h.budova}
                    {h.uklizeno && (
                      <OverlayTrigger overlay={<Tooltip>Uklizeno</Tooltip>}>
                        <span
                          className="badge badge-success"
                          style={{ marginLeft: "10px" }}
                        >
                          {h.uklizeno}
                        </span>
                      </OverlayTrigger>
                    )}
                    {h.ke_kontrole && (
                      <OverlayTrigger overlay={<Tooltip>Ke kontrole</Tooltip>}>
                        <span
                          className="badge badge-warning"
                          style={{ marginLeft: "10px" }}
                        >
                          {h.ke_kontrole}
                        </span>
                      </OverlayTrigger>
                    )}
                    {h.neuklizeno && (
                      <OverlayTrigger overlay={<Tooltip>Neuklizeno</Tooltip>}>
                        <span
                          className="badge badge-danger"
                          style={{ marginLeft: "10px" }}
                        >
                          {h.neuklizeno}
                        </span>
                      </OverlayTrigger>
                    )}
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={index+1}>
                    <Card.Body>
                      <Accordion>
                        {h.patro.map((p, index2) => (
                          <Card key={index2}>
                            <Accordion.Toggle
                              as={Card.Header}
                              eventKey={"2-" + index2}
                            >
                              {p.patro}
                              {p.uklizeno && (
                                <OverlayTrigger
                                  overlay={<Tooltip>Uklizeno</Tooltip>}
                                >
                                  <span
                                    className="badge badge-success"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    {p.uklizeno}
                                  </span>
                                </OverlayTrigger>
                              )}
                              {p.ke_kontrole && (
                                <OverlayTrigger
                                  overlay={<Tooltip>Ke kontrole</Tooltip>}
                                >
                                  <span
                                    className="badge badge-warning"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    {p.ke_kontrole}
                                  </span>
                                </OverlayTrigger>
                              )}
                              {p.neuklizeno && (
                                <OverlayTrigger
                                  overlay={<Tooltip>Neuklizeno</Tooltip>}
                                >
                                  <span
                                    className="badge badge-danger"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    {p.neuklizeno}
                                  </span>
                                </OverlayTrigger>
                              )}
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={"2-" + index2}>
                              <Card.Body>
                                <div className="row">
                                  {p.pokoj.map((pk, index3) => (
                                    <div
                                      className="col-md-2"
                                      style={{ marginBottom: "20px" }}
                                    >
                                      <Card>
                                        <Card.Header>
                                          {pk.stav === "DI" && (
                                            <OverlayTrigger
                                              overlay={
                                                <Tooltip>Neuklizeno</Tooltip>
                                              }
                                            >
                                              <span
                                                style={{ float: "right" }}
                                                className="text-danger"
                                              >
                                                <GiBrokenBottle />
                                              </span>
                                            </OverlayTrigger>
                                          )}
                                          {pk.stav === "TU" && (
                                            <OverlayTrigger
                                              overlay={
                                                <Tooltip>Ke kontrole</Tooltip>
                                              }
                                            >
                                              <span
                                                style={{ float: "right" }}
                                                className="text-warning"
                                              >
                                                <MdSupervisorAccount />
                                              </span>
                                            </OverlayTrigger>
                                          )}
                                          {pk.stav === "CL" && (
                                            <OverlayTrigger
                                              overlay={
                                                <Tooltip>Uklizeno</Tooltip>
                                              }
                                            >
                                              <span
                                                style={{ float: "right" }}
                                                className="text-success"
                                              >
                                                <MdDone />
                                              </span>
                                            </OverlayTrigger>
                                          )}
                                          {pk.pokoj}
                                        </Card.Header>
                                        <Card.Body
                                          style={{
                                            paddingTop: "0px",
                                            paddingBottom: "0px"
                                          }}
                                        >
                                          {pk.klient.map((k, index4) => (
                                            <div
                                              style={{
                                                padding: "10px 0px",
                                                borderTop:
                                                  index4 > 0
                                                    ? "solid 1px #ddd"
                                                    : ""
                                              }}
                                            >
                                              <OverlayTrigger
                                                overlay={
                                                  <Popover placement="right">
                                                    <Popover.Title>
                                                      {k.NASTUP_POKOJ} -{" "}
                                                      {k.ODCHOD_POKOJ}
                                                    </Popover.Title>
                                                    <Popover.Content>
                                                      {k.Typ_pece}
                                                    </Popover.Content>
                                                  </Popover>
                                                }
                                              >
                                                <Button
                                                  variant="link"
                                                  style={{ display: "block" }}
                                                >
                                                  {k.JMENO}
                                                </Button>
                                              </OverlayTrigger>
                                            </div>
                                          ))}
                                        </Card.Body>
                                      </Card>
                                    </div>
                                  ))}
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        ))}
                      </Accordion>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ))}
            </Accordion>
          </React.Fragment>
        ) : (
          <div className="alert alert-danger">Nic tu není...</div>
        )}
      </React.Fragment>
    );
  }
}

export default HouseKeeping;
